import i18n from "i18next";
import messages_de from "../resources/locales/de/messages.json";
import messages_en from "../resources/locales/en/messages.json";
import { getConfig } from "./config";

export const FALLBACK_LANG = "en";

const FALLBACK_ENTRY = "default"; // last resort for some data structures (i.e. menu from portal)

const resources = {
  en: {
    messages: messages_en,
  },
  de: {
    messages: messages_de,
  },
};

export function createInstance(initialLanguage, fallbackLng) {
  const i18next = i18n.createInstance();
  i18next.init(
    {
      resources,
      initImmediate: false, // important: otherwise init is deferred!
      lng: initialLanguage,
      fallbackLng: fallbackLng,
      ns: ["messages"],
      defaultNS: "messages",
      nsSeparator: ":", // explicitely set namespace separator since default does not work
      keySeparator: false, // we do not use keys in form messages.welcome
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    },
    (err, t) => {
      if (err) {
        console.error("[zebdshappframe] i18n failed initialization", err);
      } else {
        console.log("[zebdshappframe] i18n successfully initialized");
      }
    }
  );
  return i18next;
}

export function getFallbackLanguages() {
  const defaultLang = getConfigDefaultLanguage();
  if (defaultLang == null) {
    return [FALLBACK_LANG];
  } else {
    return [defaultLang, FALLBACK_LANG];
  }
}

export const i18next = createInstance(
  getDocumentLanguage(),
  getFallbackLanguages()
);

export function getFromData(data, lang, defaultLang, def) {
  if (data == null) {
    return def;
  } else if (lang && lang in data) {
    return data[lang];
  } else if (defaultLang && defaultLang in data) {
    return data[defaultLang];
  } else if (FALLBACK_LANG in data) {
    return data[FALLBACK_LANG];
  } else if (FALLBACK_ENTRY in data) {
    return data[FALLBACK_ENTRY];
  } else {
    return def;
  }
}

export function getMenuTitle(menuEntry, lang, defaultLang) {
  if (menuEntry == null) {
    return null;
  }
  const data = getFromData(menuEntry["data"], lang, defaultLang, null);
  if (data == null) {
    return null;
  }
  const result = data["title"];
  if (result == null) {
    return null;
  }
  return result;
}

export function getMenuUrl(menuEntry, lang, defaultLang) {
  if (menuEntry == null) {
    return null;
  }
  const data = getFromData(menuEntry["data"], lang, defaultLang, null);
  if (data == null) {
    return null;
  }
  const result = data["resolvedUrl"];
  if (result == null) {
    return null;
  }
  return result;
}

export function getDocumentLanguage() {
  const docLang = document.documentElement.lang;
  if (docLang && String(docLang).length > 0) {
    return docLang;
  }

  const navLangFull = navigator.language || navigator.userLanguage;
  if (navLangFull && String(navLangFull).length > 0) {
    const navLang = String(navLangFull).split("-")[0];
    if (navLang && String(navLang).length > 0) {
      return navLang;
    }
  }

  const defaultLang = getConfigDefaultLanguage();
  if (defaultLang) {
    return defaultLang;
  }

  return FALLBACK_LANG;
}

export function getConfigDefaultLanguage() {
  const config = getConfig();
  if (config && config.defaultLanguage) {
    return config.defaultLanguage;
  }
  return null;
}
